import React, { FC } from 'react';
import styles from './entity_outline_title.module.scss';

export const EntityOutlineTitle: FC<{ id: string }> = ({ children, id }) => (
  <h2 id={id} className={styles.title}>
    {children}
  </h2>
);
